export const COPPA_DESCRIPTIONS = {
  targetChildren:
    'Indicates if an app is likely directed to children under the age of 13, including “mixed audience” apps that target children under 13 but children under 13 are not the primary audience (e.g., the app also targets older teens or adults).',
  privacyPolicy:
    'Indicates if Pixalate can detect a privacy policy. The COPPA Rule requires a site/app to have a privacy policy that explicitly describes how it handles the data of children below 13.',
  personalInfo:
    'Indicates if an app requests permissions such as access to a device’s contacts, calendar, camera, or microphone. These types of permissions allow apps to collect personal information from users.',
  ipTraffic:
    'Indicates if an app is transmitting residential IP address such as the Wifi IP address from which location can be determined. The COPPA rule requires verifiable parental consent prior to collecting geolocation information from children under 13.',
  passesLocation:
    'Indicates if an app is transmitting location through disclosure of latitude and longitude coordinates. The COPPA rule requires verifiable parental consent prior to collecting geolocation information from children under 13.',
  vpcDetected:
    'Indicates if an app is seeking Verifiable Parental Consent in accordance with the COPPA Rule prior to collection, use or disclosure of personal information from children under 13.'
};

export const COPPA_TARGET_CHILDREN_LABELS: Record<
  'low' | 'high' | 'na',
  string
> = {
  low: 'General Audience',
  high: 'Child Directed',
  na: 'N/A'
};

export const COPPA_TARGET_CHILDREN_ICONS: Record<
  'low' | 'high' | 'na',
  string
> = {
  low: '/assets/images/icon-general-audience.svg',
  high: '/assets/images/icon-child-audience.svg',
  na: '/assets/images/unknown.svg'
};
